import { render, staticRenderFns } from "./ExportNominationList.vue?vue&type=template&id=566ba489&scoped=true&"
import script from "./ExportNominationList.vue?vue&type=script&lang=js&"
export * from "./ExportNominationList.vue?vue&type=script&lang=js&"
import style0 from "./ExportNominationList.vue?vue&type=style&index=0&id=566ba489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ba489",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
